export type BackgroundColors =
	'white' | 'accent' | 'gradient-80px' | 'gradient-160px' | 'gradient-50';

export const BACKGROUND_CLASS_MAP: Record<BackgroundColors, string> = {
	white: 'bg-white',
	accent: 'bg-accent-25',
	'gradient-80px':
		'bg-linear-to-b from-transparent from-[80px] to-accent-25 to-[80px]',
	'gradient-160px':
		'bg-linear-to-b from-transparent from-[160px] to-accent-25 to-[160px]',
	'gradient-50':
		'bg-linear-to-b from-transparent from-25% to-accent-25 to-75%',
};
